import React, { FC, useContext, useEffect, useState } from 'react';
import { FormattedMessage } from 'react-intl';
import styled from 'styled-components';
import { RateCardLite } from 'api/rate-cards';
import { AddButton } from 'components/atoms/button';
import { SearchInput } from 'components/atoms/input';
import { FilterBar } from 'components/molecules/filter-bar';
import { PermissionsContext } from 'contexts/permissions';
import { useTranslation } from 'hooks/use-translation';
import { RateCardsList } from './table';

const FilterBarWrapperWithoutPadding = styled(FilterBar)`
  padding: 0;
  margin-bottom: var(--layout-02);
  box-shadow: none;
`;

const SearchInputWithMargin = styled(SearchInput)`
  margin-right: var(--spacing-05);
  .ant-btn {
    border: none;
  }
`;

interface Props {
  rateCards: RateCardLite[];
  openRateCardDrawer: (rateCardId?: number) => void;
  createNewRateCardVersion: (rateCardId: number) => void;
}
export const RateCardsSection: FC<Props> = ({
  rateCards,
  openRateCardDrawer,
  createNewRateCardVersion,
}) => {
  const searchPlaceholder = useTranslation(
    'settings.rate_cards.list.header.rate_card_name',
  );

  const [searchValue, setSearchValue] = useState('');
  const [filteredRateCards, setFilteredRateCards] =
    useState<RateCardLite[]>(rateCards);

  const { canCreate } = useContext(PermissionsContext);

  useEffect(() => {
    setFilteredRateCards(
      rateCards.filter(({ rateCardName }) =>
        rateCardName.toLowerCase().includes(searchValue.toLowerCase()),
      ),
    );
  }, [rateCards, searchValue]);

  return (
    <>
      <FilterBarWrapperWithoutPadding>
        <FilterBar.Primary />
        <FilterBar.Secondary>
          <SearchInputWithMargin
            placeholder={searchPlaceholder}
            size="small"
            onChange={(e) => setSearchValue(e.target.value)}
            value={searchValue}
            direction="right"
          />
          {canCreate && (
            <AddButton
              onClick={() => {
                openRateCardDrawer(undefined);
              }}
            >
              <FormattedMessage id="settings.rate_cards.new_card.cta" />
            </AddButton>
          )}
        </FilterBar.Secondary>
      </FilterBarWrapperWithoutPadding>
      <RateCardsList
        rateCards={filteredRateCards}
        openRateCardDrawer={openRateCardDrawer}
        createNewRateCardVersion={createNewRateCardVersion}
      />
    </>
  );
};
